const UseFormValueUtils = module.exports = {};

UseFormValueUtils.syncFormValues = ({ formMethods, fieldValues = {} }) => {

    Object.entries(fieldValues).forEach(([field, value]) => {

        formMethods?.setValue?.(field, value);
    });
};

UseFormValueUtils.syncRendererStateValues = ({
    formMethods,
    setRendererState,
    fieldValues = {},
    callback
}) => {

    UseFormValueUtils.syncFormValues({
        formMethods,
        fieldValues
    });

    setRendererState?.(fieldValues, callback);
};

UseFormValueUtils.splitFormAndRendererValues = ({
    fieldValues = {},
    formFields,
    managedFields
}) => {

    const formFieldSet = new Set(formFields || managedFields || []);

    return Object.entries(fieldValues).reduce((collector, [field, value]) => {

        if (formFieldSet.has(field)) {
            collector.formValues[field] = value;
        }
        else {
            collector.rendererValues[field] = value;
        }

        return collector;
    }, {
        formValues: {},
        rendererValues: {}
    });
};

UseFormValueUtils.syncFormAndRendererValues = ({
    formMethods,
    setRendererState,
    fieldValues = {},
    formFields,
    managedFields,
    callback
}) => {

    const {
        formValues,
        rendererValues
    } = UseFormValueUtils.splitFormAndRendererValues({
        fieldValues,
        formFields,
        managedFields
    });

    UseFormValueUtils.syncFormValues({
        formMethods,
        fieldValues: formValues
    });

    if (Object.keys(rendererValues).length > 0) {
        setRendererState?.(rendererValues, callback);
        return;
    }

    callback?.();
};

UseFormValueUtils.getFieldValue = ({ formMethods, state = {}, field }) => {

    const formValue = formMethods?.getValues?.(field);

    if (typeof formValue !== 'undefined') {
        return formValue;
    }

    return state[field];
};

UseFormValueUtils.buildFieldValues = ({
    fields = [],
    formValues = {},
    getFieldValue
}) => {

    return fields.reduce((collector, field) => {

        let fieldValue = Object.prototype.hasOwnProperty.call(formValues, field)
            ? formValues[field]
            : getFieldValue(field);

        if (fieldValue === '') {
            fieldValue = null;
        }

        collector[field] = fieldValue;
        return collector;
    }, {});
};

UseFormValueUtils.buildStateSlice = ({
    state = {},
    fields = []
}) => {

    return fields.reduce((collector, field) => {

        collector[field] = state[field];
        return collector;
    }, {});
};

UseFormValueUtils.buildUiState = ({
    state = {},
    fields = []
}) => {

    return UseFormValueUtils.buildStateSlice({
        state,
        fields
    });
};
